import { Component } from '@angular/core';

@Component({
    selector: 'app-management-layout',
    templateUrl: './management-layout.component.html',
    styleUrl: './management-layout.component.scss',
    standalone: false
})
export class ManagementLayoutComponent {}
